import type React from 'react';

import * as st from './Attribute.module.scss';

type Props = {
	attribute: any;
};

const Attribute: React.FC<Props> = ({ attribute }) => {
	return (
		<>
			<span className={st.title}>{attribute.attribute.title}</span>
			{attribute.attribute.type === 'color' ? (
				<div
					className={st.color}
					style={{
						borderColor: '#' + attribute.value.code,
						backgroundColor: '#' + attribute.value.code,
					}}
				/>
			) : attribute.attribute.type === 'size' ? (
				<span className={st.value_size}>{attribute.value.title}</span>
			) : (
				<span className={st.value}>{attribute.value.title}</span>
			)}
		</>
	);
};

export default Attribute;
